import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
   providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      /* request = request.clone({
         setHeaders: {
           'X-Custom-Header': 'mi-valor-personalizado'
         }
       });
 */
       return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            console.error('Error de autenticación', error.message);
          } else if (error.status === 404) {
            console.error('Recurso no encontrado', error.message);
          } else {
            console.error('Ocurrió un error:', error.message);
          }

          return throwError(() => new Error(error.statusText));
        })
      );
   }
}
